import { LeadForm } from "@/components/LeadForm";
import { LegalDisclaimer } from "@/components/LegalDisclaimer";
import { ContactDetails } from "@/components/ContactDetails";

export const ContactSection = ({ headingLevel: H = "h2", title = "Let’s Connect" }) => {
  const Sub = H === "h1" ? "h2" : "h3";
  return (
  <section id="discovery-form" className="section bg-ivory" aria-labelledby="contact-heading" data-testid="contact-section">
    <div className="wrap grid gap-12 lg:grid-cols-12 lg:gap-16">
      <div className="lg:col-span-5">
        <p className="eyebrow mb-5">Contact Info</p>
        <H id="contact-heading" className={H === "h1" ? "text-4xl font-bold sm:text-5xl lg:text-6xl" : "h2"}>{title}</H>
        <p className="lede mt-5">Ready to Explore Ownership Opportunities?</p>
        <div className="mt-10 border-t border-line pt-8">
          <Sub className="text-xl font-semibold">Franchise Development Contact</Sub>
          <ContactDetails loc="contact" />
        </div>
      </div>
      <div className="lg:col-span-7">
        <div className="border border-line bg-paper p-6 sm:p-8 md:p-10">
          <Sub className="text-2xl font-semibold">Contact Us</Sub>
          <p className="mt-2 text-stone-600">Tell us about your goals and we’ll reach out to provide more information.</p>
          <div className="mt-8"><LeadForm /></div>
        </div>
        <div className="mt-6"><LegalDisclaimer testId="form-legal-disclaimer" /></div>
      </div>
    </div>
  </section>
  );
};
